export default __webpack_public_path__ + "static/media/browns.216e4220.png";